var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHerbicideIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 12.0009H13.5003L14.8774 15.6477C15.1243 16.3018 14.6411 17.001 13.9419 17.001H10.0598C9.36069 17.001 8.87747 16.302 9.12431 15.648L10.5003 12.0009ZM11.5003 14.0006L11.0003 15.001H13.0003L12.5003 14.0006H11.5003Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0003 23.001L11.0003 19.0009H13.0003V23.001H11.0003Z",
    fill: "#696F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8323 21.0518L14.1683 18.5556L15.8323 17.4462L17.4964 19.9424L15.8323 21.0518Z",
    fill: "#696F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50418 19.9425L8.16819 17.4463L9.8322 18.5557L8.16819 21.0519L6.50418 19.9425Z",
    fill: "#696F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18964 3.58309C4.71587 2.92134 5.18887 2.00098 6.00275 2.00098H17.9976C18.8115 2.00098 19.2845 2.92131 18.8107 3.58307L13.5003 11.0009H10.5003L5.18964 3.58309ZM7.94334 4.00098L11.5148 9.00098H12.4855L16.057 4.00098H7.94334Z",
    fill: "#696F88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHerbicideIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/herbicideIcon.105894951c039be7707ce987ab1d1b79.svg";